<template lang="pug">
.zoomable-iframe.relative.w-full.h-full.overflow-hidden
  iframe.w-full.h-full.block.origin-top-left(ref="iframe" :style="style")
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

const props = defineProps<{ zoom: number }>();

const iframe = ref<HTMLIFrameElement | null>(null);

const style = computed(() => {
  const zoom = props.zoom;

  return {
    transform: `scale(${zoom})`,
    transformOrigin: 'top left',
    width: `${100 / zoom}%`,
    height: `${100 / zoom}%`
  };
});

defineExpose({ iframe });
</script>
